<template>
    <Head title="Log in" />

    <form @submit.prevent="submit" class="flex flex-col gap-6">

        <v-input v-model="form.secret" :error="form.errors.secret" autofocus/>

        <div class="flex flex-row gap-4 items-center justify-center">

            <ButtonSecondary type="button" :href="route('logout')"  method="post" as="button">
                Отменить
            </ButtonSecondary>

            <v-button color="blue"  type="submit" :class="{ 'opacity-25': form.processing }" :disabled="form.processing">
                Проверить
            </v-button>
        </div>
    </form>
</template>

<script>
import VButton from '@/Components/Button.vue';
import ButtonSecondary from '@/Components/ButtonSecondary';
import GuestLayout from '@/Layouts/Guest.vue';
import VInput from '@/Components/2FAInput';
import InputError from "@/Components/InputError";
import Label from '@/Components/Label.vue';
import { Head, Link } from '@inertiajs/inertia-vue3';

export default {
    layout: GuestLayout,

    components: {
        VButton,
        ButtonSecondary,
        VInput,
        InputError,
        Label,
        Head,
        Link,
    },

    props: {
        canResetPassword: Boolean,
        status: String,
    },

    data() {
        return {
            form: this.$inertia.form({
                secret: '',
            })
        }
    },

    methods: {
        submit() {
            this.form.post(this.route('2fa.login'), {
                onFinish: () => this.form.reset('password'),
            })
        }
    }
}
</script>
